import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } }

  connect() {
    this.timer = setTimeout(() => this.hide(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  hide() {
    this.element.style.transition = "opacity 0.4s ease"
    this.element.style.opacity = "0"
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
  }
}
